import { LooseFormSectionContent } from '@ui-components/containers/LooseSectionContent'
import { PropsWithChildren } from 'react'
import { styled } from 'styled-components'

const SimpleSection = styled.section``

/**
 * If you need to getByLabel or have a landmark labelled by a header, use RegionWithLabel instead
 */
export const SubSectionContainer = (props: PropsWithChildren<{ ['data-testid']?: string }>) => {
  return (
    <SimpleSection {...props}>
      <LooseFormSectionContent>{props.children}</LooseFormSectionContent>
    </SimpleSection>
  )
}
